import { graphql } from "~/gql";

export const BEDROCK_GET_TASKS_FOR_PHASE_QUERY = graphql(/* GraphQL */ `
  query BedrockGetTasksForPhase(
    $matterId: Float!
    $phaseId: Float!
    $refineMode: Boolean
    $customPrompt: String
    $countryCode: String
  ) {
    bedrockGetTasksForPhase(
      matterId: $matterId
      phaseId: $phaseId
      refineMode: $refineMode
      customPrompt: $customPrompt
      countryCode: $countryCode
    ) {
      tasks
    }
  }
`);
